'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowULeft, iconArrowULeftTag } from '@ni/nimble-components/dist/esm/icons/arrow-u-left';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowULeft };
export { iconArrowULeftTag };
export const NimbleIconArrowULeft = wrap(IconArrowULeft);